




import { pageFactory } from '@/main/pages/pageFactory';
import { pageStoreBuilder } from '@/main/store/pages/page/builder';

import { CRUMB_LABEL_KEY } from './constants';

const name = 'ProdejNovychVozuEditIframe';

export default pageFactory(name, pageStoreBuilder({
	name,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
})).extend({
	props: {
		id: { type: Number },
	},
	computed: {
		src() {
			return `/DMS3/Nv/Pnv/${this.pageMode}/${this.id ?? ''}`;
		},
	},
});
